import { outreach } from '@round/api';
import { formatDate } from 'helpers';

const NO_VALUE = '—';

export type MetaItem = {
    label: string;
    value: string;
};

/**
 * The headline's figures, in the order they answer a reader's questions about a request: when it was
 * asked for, when it is due, and how much has come back. Later phases report the outreach's own
 * progress, which joins the end of the row rather than rearranging it.
 */
export function getMetaItems(request: outreach.OutreachRequest): MetaItem[] {
    return [
        { label: 'Created', value: formatDate(request.created_at) },
        // Create always sets a deadline, so an empty one can only come from a record that predates
        // the field rather than from a request made without one.
        { label: 'Deadline', value: request.deadline ? formatDate(request.deadline) : NO_VALUE },
        // Every result the sweep found, archived and already-added ones included.
        { label: 'Results', value: String(request.results_count) },
    ];
}
